import {
  PROJECT_ADD_CONTRIB_FAIL,
  PROJECT_ADD_CONTRIB_REQUEST,
  PROJECT_ADD_CONTRIB_RESET,
  PROJECT_ADD_CONTRIB_SUCCESS,
  PROJECT_ADD_PO_DOCS_FAIL,
  PROJECT_ADD_PO_DOCS_REQUEST,
  PROJECT_ADD_PO_DOCS_RESET,
  PROJECT_ADD_PO_DOCS_SUCCESS,
  PROJECT_AE_ADD_PO_DOCS_FAIL,
  PROJECT_AE_ADD_PO_DOCS_REQUEST,
  PROJECT_AE_ADD_PO_DOCS_RESET,
  PROJECT_AE_ADD_PO_DOCS_SUCCESS,
  PROJECT_ALL_LIST_FAIL,
  PROJECT_ALL_LIST_REQUEST,
  PROJECT_ALL_LIST_RESET,
  PROJECT_ALL_LIST_SUCCESS,
  PROJECT_ARCHIVE_FAIL,
  PROJECT_ARCHIVE_REQUEST,
  PROJECT_ARCHIVE_RESET,
  PROJECT_ARCHIVE_SUCCESS,
  PROJECT_CREATE_FAIL,
  PROJECT_CREATE_REQUEST,
  PROJECT_CREATE_RESET,
  PROJECT_CREATE_SUCCESS,
  PROJECT_CURRENT_STEP,
  PROJECT_CURRENT_STEP_RESET,
  PROJECT_DELETE_FAIL,
  PROJECT_DELETE_REQUEST,
  PROJECT_DELETE_RESET,
  PROJECT_DELETE_SUCCESS,
  PROJECT_DELIVERABLES_FAIL,
  PROJECT_DELIVERABLES_REQUEST,
  PROJECT_DELIVERABLES_RESET,
  PROJECT_DELIVERABLES_SUCCESS,
  PROJECT_DETAILS_FAIL,
  PROJECT_DETAILS_REQUEST,
  PROJECT_DETAILS_RESET,
  PROJECT_DETAILS_SUCCESS,
  PROJECT_DOCUMENT_SIGNED_FAIL,
  PROJECT_DOCUMENT_SIGNED_REQUEST,
  PROJECT_DOCUMENT_SIGNED_RESET,
  PROJECT_DOCUMENT_SIGNED_SUCCESS,
  PROJECT_EXIT_REQUEST,
  PROJECT_EXIT_RESET,
  PROJECT_FILES_FAIL,
  PROJECT_FILES_REQUEST,
  PROJECT_FILES_RESET,
  PROJECT_FILES_SUCCESS,
  PROJECT_FILE_DELETE_FAIL,
  PROJECT_FILE_DELETE_REQUEST,
  PROJECT_FILE_DELETE_RESET,
  PROJECT_FILE_DELETE_SUCCESS,
  PROJECT_LIST_FAIL,
  PROJECT_LIST_REQUEST,
  PROJECT_LIST_RESET,
  PROJECT_LIST_SUCCESS,
  PROJECT_MARK_AS_PAID_FAIL,
  PROJECT_MARK_AS_PAID_REQUEST,
  PROJECT_MARK_AS_PAID_RESET,
  PROJECT_MARK_AS_PAID_SUCCESS,
  PROJECT_REMOVE_CONTRIB_FAIL,
  PROJECT_REMOVE_CONTRIB_REQUEST,
  PROJECT_REMOVE_CONTRIB_RESET,
  PROJECT_REMOVE_CONTRIB_SUCCESS,
  PROJECT_REMOVE_DELIVERABLE_FAIL,
  PROJECT_REMOVE_DELIVERABLE_REQUEST,
  PROJECT_REMOVE_DELIVERABLE_RESET,
  PROJECT_REMOVE_DELIVERABLE_SUCCESS,
  PROJECT_REQUESTS_DETAILS_FAIL,
  PROJECT_REQUESTS_DETAILS_REQUEST,
  PROJECT_REQUESTS_DETAILS_RESET,
  PROJECT_REQUESTS_DETAILS_SUCCESS,
  PROJECT_SUBMIT_QUOTE_FAIL,
  PROJECT_SUBMIT_QUOTE_REQUEST,
  PROJECT_SUBMIT_QUOTE_RESET,
  PROJECT_SUBMIT_QUOTE_SUCCESS,
  PROJECT_UPDATE_FAIL,
  PROJECT_UPDATE_NO_TOAST,
  PROJECT_UPDATE_QUOTE_FAIL,
  PROJECT_UPDATE_QUOTE_REQUEST,
  PROJECT_UPDATE_QUOTE_RESET,
  PROJECT_UPDATE_QUOTE_SUCCESS,
  PROJECT_UPDATE_REQUEST,
  PROJECT_UPDATE_RESET,
  PROJECT_UPDATE_SUCCESS,
} from '../constants/projectConstants'

export const projectCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_CREATE_REQUEST:
      return { loading: true }
    case PROJECT_CREATE_SUCCESS:
      return { loading: false, success: true, createdProject: action.payload }
    case PROJECT_CREATE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_CREATE_RESET:
      return {}
    default:
      return state
  }
}

export const projectDetailsReducer = (state = { project: {} }, action) => {
  switch (action.type) {
    case PROJECT_DETAILS_REQUEST:
      return { ...state, loading: true }
    case PROJECT_DETAILS_SUCCESS:
      return { loading: false, project: action.payload }
    case PROJECT_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_DETAILS_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectFilesReducer = (state = { items: [] }, action) => {
  switch (action.type) {
    case PROJECT_FILES_REQUEST:
      return { ...state, loading: true }
    case PROJECT_FILES_SUCCESS:
      return { loading: false, items: action.payload }
    case PROJECT_FILES_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_FILES_RESET:
      return { items: [] }
    default:
      return state
  }
}

export const projectRequestsDetailsReducer = (
  state = { projectRequests: [] },
  action
) => {
  switch (action.type) {
    case PROJECT_REQUESTS_DETAILS_REQUEST:
      return { ...state, loading: true }
    case PROJECT_REQUESTS_DETAILS_SUCCESS:
      return { loading: false, projectRequests: action.payload }
    case PROJECT_REQUESTS_DETAILS_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_REQUESTS_DETAILS_RESET:
      return { projectRequests: [] }
    default:
      return state
  }
}

export const projectUpdateReducer = (state = { project: {} }, action) => {
  switch (action.type) {
    case PROJECT_UPDATE_REQUEST:
      return { loading: true }
    case PROJECT_UPDATE_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_UPDATE_NO_TOAST:
      return { ...state, loading: false, project: action.payload }
    case PROJECT_UPDATE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_UPDATE_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectSubmitQuoteReducer = (state = { project: {} }, action) => {
  switch (action.type) {
    case PROJECT_SUBMIT_QUOTE_REQUEST:
      return { loading: true }
    case PROJECT_SUBMIT_QUOTE_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_SUBMIT_QUOTE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_SUBMIT_QUOTE_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectUpdateQuoteReducer = (state = { project: {} }, action) => {
  switch (action.type) {
    case PROJECT_UPDATE_QUOTE_REQUEST:
      return { loading: true }
    case PROJECT_UPDATE_QUOTE_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_UPDATE_QUOTE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_UPDATE_QUOTE_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectAddPODocsReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_ADD_PO_DOCS_REQUEST:
      return { loading: true }
    case PROJECT_ADD_PO_DOCS_SUCCESS:
      return { loading: false, success: true }
    case PROJECT_ADD_PO_DOCS_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_ADD_PO_DOCS_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectAEAddPODocsReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_AE_ADD_PO_DOCS_REQUEST:
      return { loading: true }
    case PROJECT_AE_ADD_PO_DOCS_SUCCESS:
      return { loading: false, success: true }
    case PROJECT_AE_ADD_PO_DOCS_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_AE_ADD_PO_DOCS_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectAddContributorsReducer = (
  state = { project: {} },
  action
) => {
  switch (action.type) {
    case PROJECT_ADD_CONTRIB_REQUEST:
      return { loading: true }
    case PROJECT_ADD_CONTRIB_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_ADD_CONTRIB_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_ADD_CONTRIB_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectRemoveContributorsReducer = (
  state = { project: {} },
  action
) => {
  switch (action.type) {
    case PROJECT_REMOVE_CONTRIB_REQUEST:
      return { loading: true }
    case PROJECT_REMOVE_CONTRIB_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_REMOVE_CONTRIB_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_REMOVE_CONTRIB_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectListReducer = (state = { projects: [] }, action) => {
  switch (action.type) {
    case PROJECT_LIST_REQUEST:
      return { ...state, loading: true }
    case PROJECT_LIST_SUCCESS:
      return { loading: false, success: true, projects: action.payload }
    case PROJECT_LIST_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_LIST_RESET:
      return {}
    default:
      return state
  }
}

export const allProjectListReducer = (
  state = { projects: undefined, totalPages: undefined },
  action
) => {
  switch (action.type) {
    case PROJECT_ALL_LIST_REQUEST:
      return { ...state, loading: true }
    case PROJECT_ALL_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        projects: action.payload.projects,
        totalProjects: action.payload.totalProjects,
      }
    case PROJECT_ALL_LIST_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_ALL_LIST_RESET:
      return {}
    default:
      return state
  }
}

export const projectStepReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_CURRENT_STEP:
      return { currentStep: action.payload }
    case PROJECT_CURRENT_STEP_RESET:
      return {}
    default:
      return state
  }
}

export const projectExitReducer = (state = { exit: false }, action) => {
  switch (action.type) {
    case PROJECT_EXIT_REQUEST:
      return { exit: true }
    case PROJECT_EXIT_RESET:
      return { exit: false }
    default:
      return state
  }
}

export const projectDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_DELETE_REQUEST:
      return { loading: true }
    case PROJECT_DELETE_SUCCESS:
      return { loading: false, success: true }
    case PROJECT_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_DELETE_RESET:
      return {}
    default:
      return state
  }
}

export const projectFileDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_FILE_DELETE_REQUEST:
      return { loading: true }
    case PROJECT_FILE_DELETE_SUCCESS:
      return { loading: false, success: true }
    case PROJECT_FILE_DELETE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_FILE_DELETE_RESET:
      return {}
    default:
      return state
  }
}

export const projectMarkAsPaidReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_MARK_AS_PAID_REQUEST:
      return { loading: true }
    case PROJECT_MARK_AS_PAID_SUCCESS:
      return { loading: false, success: true }
    case PROJECT_MARK_AS_PAID_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_MARK_AS_PAID_RESET:
      return {}
    default:
      return state
  }
}

export const projectDocumentSignedReducer = (state = {}, action) => {
  switch (action.type) {
    case PROJECT_DOCUMENT_SIGNED_REQUEST:
      return { loading: true }
    case PROJECT_DOCUMENT_SIGNED_SUCCESS:
      return { loading: false, success: true }
    case PROJECT_DOCUMENT_SIGNED_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_DOCUMENT_SIGNED_RESET:
      return {}
    default:
      return state
  }
}

export const projectRemoveDeliverableReducer = (
  state = { project: {} },
  action
) => {
  switch (action.type) {
    case PROJECT_REMOVE_DELIVERABLE_REQUEST:
      return { loading: true }
    case PROJECT_REMOVE_DELIVERABLE_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_UPDATE_NO_TOAST:
      return {
        ...state,
        loading: false,
        project: action.payload,
      }
    case PROJECT_REMOVE_DELIVERABLE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_REMOVE_DELIVERABLE_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectDeliverablesReducer = (state = { project: {} }, action) => {
  switch (action.type) {
    case PROJECT_DELIVERABLES_REQUEST:
      return { loading: true }
    case PROJECT_DELIVERABLES_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_DELIVERABLES_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_DELIVERABLES_RESET:
      return { project: {} }
    default:
      return state
  }
}

export const projectArchiveReducer = (state = { project: {} }, action) => {
  switch (action.type) {
    case PROJECT_ARCHIVE_REQUEST:
      return { loading: true }
    case PROJECT_ARCHIVE_SUCCESS:
      return { loading: false, success: true, project: action.payload }
    case PROJECT_ARCHIVE_FAIL:
      return { loading: false, error: action.payload }
    case PROJECT_ARCHIVE_RESET:
      return { project: {} }
    default:
      return state
  }
}
